/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const GeneratingText: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div({
	marginLeft: token('space.025'),
	color: token('color.text.subtlest'),
	font: token('font.body'),
});
